import React, { useState } from "react";
import FeatureHeader from "../components/FeatureHeader";
import "./Intake.css";

const supportOptions = [
  "Funds",
  "Pacifiers",
  "Clothes",
  "Diapering",
  "Feeding",
  "Other",
];

export default function Intake() {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    babyWeight: "",
    needs: []
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [failed, setFailed] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setSubmitted(false);
  }

  function handleNeedToggle(option) {
    setFormData((current) => {
      const needs = current.needs.includes(option)
        ? current.needs.filter((item) => item !== option)
        : [...current.needs, option];

      return { ...current, needs };
    });
    setSubmitted(false);
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setFailed(false);

    try {
      const res = await fetch("/api/intake", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

      if (!res.ok) {
        throw new Error("Request failed");
      }

      setSubmitted(true);
    } catch (err) {
      setFailed(true);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="intake-page">
      <FeatureHeader badge="For NICU and PICU families" icon="heart" title="Request support">
        We’re here for the unexpected moments. Whether you need practical help
        with diapers, feeding essentials, or grocery and gas support, we want to
        make sure your family is supported during this season.
      </FeatureHeader>

      <section className="intake-section">
        <div className="container intake-layout">
          <form className="intake-form" onSubmit={handleSubmit}>
            <label>
              Name
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your full name"
                required
              />
            </label>

            <label>
              Address
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Street address, city, state, ZIP"
                required
              />
            </label>

            <label>
              Baby weight
              <input
                type="text"
                name="babyWeight"
                value={formData.babyWeight}
                onChange={handleChange}
                placeholder="Example: 5 lb 8 oz"
                required
              />
            </label>

            <fieldset>
              <legend>What are you looking for? (optional)</legend>
              <div className="checkbox-grid">
                {supportOptions.map((option) => (
                  <label key={option} className="check-option">
                    <input
                      type="checkbox"
                      checked={formData.needs.includes(option)}
                      onChange={() => handleNeedToggle(option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </fieldset>

            <button type="submit" className="btn" disabled={submitting}>
              {submitting ? "Submitting…" : "Submit intake"}
            </button>

            {submitted && (
              <p className="form-success">
                Thanks for reaching out. Your intake has been submitted and we’ll review it soon.
              </p>
            )}

            {failed && (
              <p className="form-error">
                Something went wrong and your intake didn’t send. Please try again, or
                email us at <a href="mailto:families@bugandfrog.org">families@bugandfrog.org</a>.
              </p>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}
